// Smart Sash Admin Panel - Header Component
// Top navigation bar with user menu

import { VersionInfo } from '@/components/common';
import { useAuth } from '@/services/auth';
import React from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  onToggleSidebar: () => void;
}

/**
 * Header Component
 */
export const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm">
      <div className="container-fluid">
        {/* Sidebar Toggle */}
        <button
          className="btn btn-link text-white me-3"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <i className="fas fa-bars"></i>
        </button>

        {/* Brand */}
        <Link className="navbar-brand" to="/dashboard">
          <i className="fas fa-shield-alt me-2"></i>
          SmartSash Portal
        </Link>

        {/* Right Side Menu */}
        <div className="ms-auto d-flex align-items-center">
          <div className="me-3">
            <VersionInfo />
          </div>

          {/* User Menu */}
          <div className="dropdown">
            <button
              className="btn btn-link text-white d-flex align-items-center text-decoration-none"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-user-circle fa-lg me-2"></i>
              <span className="d-none d-md-inline">{user?.firstName || user?.email}</span>
              <i className="fas fa-caret-down ms-2"></i>
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <h6 className="dropdown-header">{user?.email}</h6>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button className="dropdown-item text-danger" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
